// Nombre de la etapa con su avance en el embudo para que se vea cual va mas adelante:
// "1/6 Nuevo", "2/6 Contactado"... El ultimo paso (el 6) es cerrar ganado, por eso Ganado y
// Perdido van sin numero. Se calcula con el orden de las etapas, asi que si agregan o
// reordenan etapas los numeros se ajustan solos.
export function etiquetasEtapas(etapas) {
  const mapa = {};
  (etapas || []).forEach((e) => (mapa[e._id] = e.nombre));
  const abiertas = (etapas || [])
    .filter((e) => (e.tipo || "abierta") === "abierta")
    .sort((a, b) => a.orden - b.orden);
  abiertas.forEach((e, i) => (mapa[e._id] = `${i + 1}/${abiertas.length + 1} ${e.nombre}`));
  return mapa;
}

// Etiqueta de una etapa (objeto poblado o id). Si no esta en el mapa, su nombre tal cual.
export const nombreEtapa = (mapa, etapa) =>
  !etapa ? "" : mapa[etapa._id || etapa] || etapa.nombre || "";
